export default function getFormattedOffset(timeZoneInfo) {
  function pad(number, includePrefix) {
    var response = ''
    if (includePrefix) {
      response += number < 0 ? '-' : '+'
    }

    response +=
      Array(Math.max(2 - String(Math.abs(number)).length + 1, 0)).join(0) +
      Math.abs(number)

    return response
  }
  var hours = pad(timeZoneInfo.offsetHour, true)
  var minutes = pad(timeZoneInfo.offsetMinute, false)
  var formattedOffset = hours + ':' + minutes
  return formattedOffset
}
